export const URL_API = process.env.REACT_APP_API_URL || 'http://localhost:9000';

/** Opcional: região explícita no Video.connect (ex. br1). Vazio = SDK usa GLL. */
export const TWILIO_VIDEO_REGION = (process.env.REACT_APP_TWILIO_VIDEO_REGION || '').trim();
